import { render, staticRenderFns } from "./ModalObjectiveDetail.vue?vue&type=template&id=27f6481b&scoped=true&lang=pug&"
import script from "./ModalObjectiveDetail.vue?vue&type=script&lang=ts&"
export * from "./ModalObjectiveDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ModalObjectiveDetail.vue?vue&type=style&index=0&id=27f6481b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f6481b",
  null
  
)

export default component.exports